var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"rightPanel",staticClass:"rightPanel-container",class:{show:_vm.show}},[_c('div',{staticClass:"rightPanel-background"})])
}
var staticRenderFns = []

export { render, staticRenderFns }